// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatRFC3339/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatRFC3339 = convertToFP(fn, 1);
export default formatRFC3339;